<template>
  <span :class="getStatusClass(item)">
    {{ $t('profile-manager.query.status.' + getStatusMod(item) ) }}
  </span>
</template>

<script>
import { RegisterStatus } from 'sigma-mappings';

export default {
  props: { item: Object },
  methods: {
    getStatusMod(profile) {
      switch (profile.registrationStatus) {
        case RegisterStatus.BLOCKED:
          return 'blocked';
        case RegisterStatus.ACTIVE:
          return 'active';
        default:
          throw new Error(`Unknown status: "${profile.registrationStatus}".`);
      }
    },
    getStatusClass(profile) {
      switch (profile.registrationStatus) {
        case RegisterStatus.BLOCKED:
          return 'text-red';
        case RegisterStatus.ACTIVE:
          return 'text-green';
        default:
          throw new Error(`Unknown status: "${profile.registrationStatus}".`);
      }
    },
  },
};
</script>
